import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  Para,
  Large,
  Language,
} from "./styles";

const Footer = ({ t }: any) => {

  return (
    <>
      <FooterSection>
      <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large to="/terms">{t("Terms")}</Large>
              <Large to="/accountDeletion">{t("Delete account")}</Large>
              <Large to="/PrivacyPolicy">Privacy Policy</Large>
            </Col>

            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Large to="/">{t("About")}</Large>
              <Large to="/">{t("Support Center")}</Large>
              <Large to="/">{t("Customer Support")}</Large>
            </Col>
          </Row>
        <Row justify={"space-around"} style={{textAlign: "center"}}><Para>© 2024 DevOps as a Service Inc. All Rights Reserved.</Para></Row>
      </Container>

      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
